
import GalleryCardPropsType from '../../types/GalleryCardPropsType'
import GalleryCard from '../cards/GalleryCard'

const BackgroundAndCard = (
    { 
        card, 
        background } : { 
            card : GalleryCardPropsType, 
            background : { 
                src : string, 
                alt : string
            } 
    }
) => {
  return (
    <div className="background-and-card-section">
        <img src={background.src} alt={background.alt} className="background" />
        <div className='wrapper-small'>
            <div className='card-container'>
                <GalleryCard 
                    title={card.title}
                    subtitle={card.subtitle}
                    image={card.image}
                    list={card.list}
                    button={card.button}
                />
            </div>
        </div>
    </div>
  )
}

export default BackgroundAndCard